<script setup lang="ts">
import type { Icon } from "@kippie/ui";

const { values } = defineProps<{
	values?: string;
}>();

const usps = computed(() => {
	if (!values) return [];

	const rows = values.split("\n");
	if (rows.length === 0) return [];

	return rows.reduce(
		(usps, row) => {
			const [icon, text] = row.split(";");
			if (!icon || !text) return usps;

			usps.push({ icon, text });
			return usps;
		},
		[] as Array<{ icon: string; text: string }>
	);
});
</script>

<template>
	<div class="rounded-lg border border-dashed border-brown p-6 flex flex-col gap-3 text-sm" v-if="usps.length > 0">
		<div class="flex gap-2" v-for="usp in usps" :key="usp.text">
			<div class="h-6 w-6">
				<SvgIcon :name="usp.icon as Icon" />
			</div>
			<span class="font-medium">{{ usp.text }}</span>
		</div>
	</div>
</template>
